import { observer } from "mobx-react";
import AsyncPaginatedSelect from "~/components/AsyncPaginatedCombobox";
import { OrganizationalUnitId } from "~/document";
import organizationalUnitStore from "~/stores/organizationalUnits";
import { useEffect } from "react";

interface Props {
  value: OrganizationalUnitId[];
  onChange: (newValue: OrganizationalUnitId[]) => void;
  selectProps?: any;
  onlyActive?: boolean;
}

const OrganizationalUnitSelect = observer((props: Props) => {
  const fetcher = organizationalUnitStore.f;
  const idToOpt = (id: OrganizationalUnitId) => {
    const item = fetcher.items[id];
    if (!item) return null;
    return {
      label: item.name,
      value: item.id,
    };
  };

  useEffect(() => {
    fetcher.load("", null, props.onlyActive ? { is_confirmed: "true" } : undefined);
  }, []);

  const valueKey = props.value.join(",");
  useEffect(() => {
    props.value.filter((id) => id != null && !fetcher.items[id]).forEach((id) => fetcher.loadItem(id));
  }, [valueKey]);

  return (
    <AsyncPaginatedSelect
      fetcher={organizationalUnitStore.f}
      itemIdToOption={idToOpt}
      value={props.value}
      onChange={props.onChange}
      additionalSearchOptions={
        props.onlyActive
          ? {
              is_confirmed: "true",
            }
          : {}
      }
      selectProps={{
        ...(props.selectProps || {}),
      }}
    />
  );
});

export default OrganizationalUnitSelect;
